import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import SuspenseRecovery from "@/components/SuspenseRecovery";

export default function AdminRoute() {
  const { user, isAdmin, isAuthReady, loading } = useAuth();

  if (loading || !isAuthReady) {
    return <SuspenseRecovery message="Checking admin access" />;
  }

  if (!user) return <Navigate to="/auth" replace />;
  if (!isAdmin) return <Navigate to="/chats" replace />;

  return <Outlet />;
}
